import Eccomerce from '../assets/eccomercejs.PNG';
import TodoApp from '../assets/todoapp.jpg';
import Chat from '../assets/chat.jpg';
import ContactCrud from '../assets/contact-crud.jpg';
import Pokedex from '../assets/pokedex.jpg';

const data = [
  {
    id: 1,
    title: 'EccomerceJS',
    description: 'projects.eccomerce',
    image: Eccomerce,
    skills: ['REACT', 'Hooks', 'MaterialUI', 'APIs'],
    githubLink: 'https://github.com/benjatestaferri7/E-Commerce-js',
    webLink: 'https://ecommercejspractice.netlify.app/',
    githubAlt: 'eccomerce-github-alt',
    webAlt: 'eccomerce-web-alt'
  },
  {
    id: 2,
    title: 'Todo App',
    description: 'projects.to-do',
    image: TodoApp,
    skills: ['REACT', 'Hooks', 'CSS3'],
    githubLink: 'https://github.com/benjatestaferri7/todo-app',
    webLink: 'https://todoappbtg.netlify.app/',
    githubAlt: 'to-do-github-alt',
    webAlt: 'to-do-web-alt'
  },
  {
    id: 3,
    title: 'Chat App',
    description: 'projects.chat-app',
    image: Chat,
    skills: ['REACT', 'Hooks', 'CSS3', 'APIs'],
    githubLink: 'https://github.com/benjatestaferri7/chat-application',
    webLink: 'https://housechat.netlify.app/',
    githubAlt: 'chat-app-github-alt',
    webAlt: 'chat-app-web-alt'
  },
  {
    id: 4,
    title: 'Firebase Crud',
    description: 'projects.firebase-crud',
    image: ContactCrud,
    skills: ['REACT', 'Hooks', 'Bootstrap', 'Firebase'],
    githubLink: 'https://github.com/benjatestaferri7/react-firebase-crud',
    webLink: 'https://contacts-crud.netlify.app/',
    githubAlt: 'firebase-crud-github-alt',
    webAlt: 'firebase-crud-web-alt'
  },
  {
    id: 5,
    title: 'Pokedex',
    description: 'projects.pokedex',
    image: Pokedex,
    skills: ['REACT', 'Hooks', 'CSS3', 'APIs'],
    githubLink: 'https://github.com/benjatestaferri7/challenge-pokedex',
    webLink: 'https://pokedex-btg.netlify.app/',
    githubAlt: 'pokedex-github-alt',
    webAlt: 'pokedex-web-alt'
  }
];

export default data;
